<template>
  <v-row class="add-client-form no-padding">
    <successModal
      ref="success_modal"
      v-on:confirm="closeSuccessModal"
    ></successModal>
    <div class="col-md-12 no-padding mt-4">
      <div class="blue-underline row" style="margin: -11px">
        <div class="col-md-12">
          <h3 class="form-title font ml-2 mb-2">New Client</h3>
        </div>
      </div>
    </div>

    <div class="col-md-12 row-height">
      <v-form v-model.trim="valid" ref="form" class="row mt-3">
        <div class="col-md-6">
          <div class="col-md-12">
            <h3 class="comp-info ml-2 mb-2 text-underline">
              Company Information
            </h3>
          </div>
          <div class="col-md-12 pt-2 pb-0">
            <label class="font" for="">Company Name</label>
            <div style="position: relavite">
              <v-text-field
                placeholder="Search by company name"
                solo
                v-model="search"
                @keyup="getClientsOnKeyUp()"
              >
              </v-text-field>

              <div
                v-if="clients.length > 0 && search.length > 0 && display"
                style="
                  position: absolute;
                  overflow-y: auto;
                  max-height: 300px;
                  width: 580px;
                  z-index: 99;
                  background-color: white;
                "
              >
                <div>
                  <ul>
                    <li
                      v-for="(item, index) in clients"
                      @click="selected(item)"
                      :key="index"
                      style="
                        list-style: none;
                        border: 0.5px solid rgba(179, 177, 177, 0.5);
                        padding: 2px;
                      "
                    >
                      {{ item.companyName }}
                    </li>
                  </ul>
                </div>
              </div>
              <div
                v-if="noResult && search!= ''"
                style="
                  position: absolute;
                  overflow-y: auto;
                  height: 110px;
                  z-index: 99;
                  background-color: #f5f6f8;
                "
                class="col-md-4 col-lg-4"
              >
                <div>
                  <ul class="d-md-flex">
                    <p class="my-1 mr-3 mt-4">No results with this name.</p>
                    <v-btn
                      @click="invite = true"
                      class="my-1 gray-border-buttons mt-3"
                    >
                      <svg
                        class="mr-2"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 7.5H15"
                          stroke="#707070"
                          stroke-width="2"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.5 0V15"
                          stroke="#707070"
                          stroke-width="2"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Invite Company
                    </v-btn>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 pt-0 pb-0">
            <label class="font text-gray" for="">Tax ID / EN</label>
            <v-text-field
              v-model.trim="taxId"
              @keyup="showSlash($event)"
              solo
              placeholder="00-0000000"
              counter="10"
              maxlength="10"
            ></v-text-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="col-md-12 d-flex">
            <div class="col-md-9">
              <h3 class="comp-info ml-2 mb-2 mt-1 text-underline mobile">
                TPA / Carrier Information
              </h3>
            </div>
            <div class="col-md-3 ml-auto">
              <!-- <v-btn
                @click="invite = true"
                class="my-1 gray-border-buttons"
              >
                <svg
                  class="mr-2"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 7.5H15"
                    stroke="#707070"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.5 0V15"
                    stroke="#707070"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                </svg>
                Invite Company
              </v-btn>  -->
            </div>
          </div>
          <div class="col-md-12 d-flex">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <!-- <th class="text-left">TPA NAME</th>
                    <th class="text-left">CONTACT</th>
                    <th class="text-left">EMAIL</th> -->
                  </tr>
                </thead>

                <tbody>
                  <tr v-if="list.tpas && list.tpas.length > 0">
                    <td class="font-weight-bold text-gray">TPA NAME</td>
                    <td v-if="list.tpas" class="text-end" >
                      {{
                        list.tpas[0].companyName
                          ? list.tpas[0].companyName
                          : "/"
                      }}
                    </td>
                    <td v-else class="text-end">/</td>

                  </tr>
                  <tr v-if="list.tpas && list.tpas.length > 0">
                    <td class="font-weight-bold text-gray">CONTACT FIRST NAME</td>
                    <td v-if="list.tpas[0].primaryContact" class="text-end">
                      {{
                        list.tpas[0].primaryContact.firstName
                          ? list.tpas[0].primaryContact.firstName
                          : "/"
                      }}
                    </td>
                    <td v-else class="text-end"> /</td>

                  </tr>
                  <tr v-if="list.tpas && list.tpas.length > 0">
                    <td class="font-weight-bold text-gray">CONTACT LAST NAME</td>
                    <td v-if="list.tpas[0].primaryContact" class="text-end">
                      {{
                        list.tpas[0].primaryContact.lastName
                          ? list.tpas[0].primaryContact.lastName
                          : "/"
                      }}
                    </td>
                    <td v-else class="text-end">/</td>

                  </tr>
                  <tr v-if="list.tpas && list.tpas.length > 0">
                    <td class="font-weight-bold text-gray">E-MAIL</td>
                    <td v-if="list.tpas[0].primaryContact" class="text-end">
                      {{
                        list.tpas[0].primaryContact.email
                          ? list.tpas[0].primaryContact.email
                          : "/"
                      }}
                    </td>
                   <td v-else class="text-end">/</td>

                  </tr>

                  <!-- <tr v-if="list.tpas && list.tpas.length > 0">
                    <td>
                      {{
                        list.tpas[0].companyName
                          ? list.tpas[0].companyName
                          : "/"
                      }}
                    </td>
                    <td v-if="list.tpas[0].primaryContact">
                      {{
                        list.tpas[0].primaryContact.firstName
                          ? list.tpas[0].primaryContact.firstName
                          : "/"
                      }}
                      {{
                        list.tpas[0].primaryContact.lastName
                          ? list.tpas[0].primaryContact.lastName
                          : ""
                      }}
                    </td>
                    <td v-else>/</td>
                    <td v-if="list.tpas[0].primaryContact">
                      <a class="text-underline"></a
                      >{{
                        list.tpas[0].primaryContact.email
                          ? list.tpas[0].primaryContact.email
                          : "/"
                      }}
                    </td>
                    <td v-else>/</td>

                  </tr> -->
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </v-form>
    </div>
    <div class="col-md-12 no-padding">
      <div class="gray-underline-wizard row margin-l-11">
        <div class="text-end justify-end col-md-12 mt-5 mb-5 pb-5 pr-5">
          <span
            class="mr-5 text-underline blue--text pointer pr-5"
            @click="$router.go(-1)"
            >Cancel</span
          >
          <span
            class="text-underline blue--text pointer pr-5"
            @click="addClient()"
            >Add</span
          >
        </div>
      </div>
    </div>
    <v-dialog v-model.trim="requestDialog" width="800" class="success-modal">
      <v-card class="text-center">
        <v-card-text class="success-modal pt-5">
          <span align="end" class="pt-0 pr-0">
            <p class="font-weight-bold" @click="requestDialog = false">X</p>
          </span>
          <div class="display">
            <div class="text-center">
              <svg
                width="126"
                height="112"
                viewBox="0 0 126 112"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1017_28415)">
                  <path
                    d="M124.403 42.8311C124.358 42.8311 124.315 42.8174 124.278 42.7918L63.629 0.633045C63.4444 0.505346 63.2251 0.437101 63.0005 0.437483C62.776 0.437865 62.5569 0.506856 62.3727 0.635183L2.16072 42.7914C2.1131 42.8248 2.05416 42.8379 1.99686 42.8278C1.93956 42.8178 1.8886 42.7854 1.8552 42.7379C1.8218 42.6904 1.80868 42.6315 1.81873 42.5743C1.82879 42.5171 1.86119 42.4663 1.90882 42.4329L62.1209 0.27671C62.3787 0.0970783 62.6854 0.000517809 62.9998 2.07673e-06C63.3142 -0.000513655 63.6213 0.0950393 63.8796 0.273824L124.529 42.4325C124.567 42.4592 124.596 42.4973 124.611 42.5414C124.626 42.5855 124.626 42.6333 124.612 42.6778C124.598 42.7222 124.571 42.7611 124.533 42.7887C124.495 42.8162 124.45 42.8311 124.403 42.8311Z"
                    fill="#3F3D56"
                  />
                  <path
                    d="M5.60156 44.3256L63.0603 1.82104L120.955 47.35L66.0209 79.855L36.1963 73.0694L5.60156 44.3256Z"
                    fill="#E6E6E6"
                  />
                  <path
                    d="M38.7139 99.9318H10.3279C10.1536 99.9321 9.98095 99.898 9.81985 99.8316C9.65876 99.7651 9.51236 99.6677 9.38903 99.5447C9.2657 99.4218 9.16787 99.2758 9.10112 99.1151C9.03436 98.9544 9 98.7821 9 98.6081C9 98.4342 9.03436 98.2619 9.10112 98.1012C9.16787 97.9405 9.2657 97.7945 9.38903 97.6715C9.51236 97.5486 9.65876 97.4511 9.81985 97.3847C9.98095 97.3183 10.1536 97.2842 10.3279 97.2844H38.7139C38.8882 97.2842 39.0609 97.3183 39.2219 97.3847C39.383 97.4511 39.5294 97.5486 39.6528 97.6715C39.7761 97.7945 39.8739 97.9405 39.9407 98.1012C40.0074 98.2619 40.0418 98.4342 40.0418 98.6081C40.0418 98.7821 40.0074 98.9544 39.9407 99.1151C39.8739 99.2758 39.7761 99.4218 39.6528 99.5447C39.5294 99.6677 39.383 99.7651 39.2219 99.8316C39.0609 99.898 38.8882 99.9321 38.7139 99.9318Z"
                    fill="#16407A"
                  />
                  <path
                    d="M20.5122 94.2407H10.3279C10.1536 94.2409 9.98095 94.2068 9.81985 94.1404C9.65876 94.074 9.51236 93.9765 9.38903 93.8536C9.2657 93.7306 9.16787 93.5846 9.10112 93.4239C9.03436 93.2632 9 93.0909 9 92.917C9 92.743 9.03436 92.5707 9.10112 92.41C9.16787 92.2493 9.2657 92.1033 9.38903 91.9804C9.51236 91.8574 9.65876 91.76 9.81985 91.6935C9.98095 91.6271 10.1536 91.593 10.3279 91.5933H20.5122C20.6865 91.593 20.8591 91.6271 21.0202 91.6935C21.1813 91.76 21.3277 91.8574 21.451 91.9804C21.5743 92.1033 21.6722 92.2493 21.7389 92.41C21.8057 92.5707 21.84 92.743 21.84 92.917C21.84 93.0909 21.8057 93.2632 21.7389 93.4239C21.6722 93.5846 21.5743 93.7306 21.451 93.8536C21.3277 93.9765 21.1813 94.074 21.0202 94.1404C20.8591 94.2068 20.6865 94.2409 20.5122 94.2407Z"
                    fill="#16407A"
                  />
                  <path
                    d="M63.8685 67.9999C63.6528 68.0001 63.439 67.9583 63.2393 67.8768L27.8027 53.2006V7.26147C27.8032 6.85525 27.9651 6.46579 28.2529 6.17855C28.5407 5.8913 28.9308 5.72972 29.3378 5.72925H97.3203C97.7273 5.72972 98.1174 5.8913 98.4052 6.17855C98.693 6.46579 98.8549 6.85525 98.8554 7.26147V53.2327L98.7888 53.2611L64.5168 67.8697C64.3115 67.9557 64.0911 68 63.8685 67.9999Z"
                    fill="white"
                  />
                  <path
                    d="M63.8688 68.1093C63.6387 68.1095 63.4108 68.065 63.1978 67.9782L27.6934 53.2738V7.26154C27.6939 6.82629 27.8673 6.40902 28.1756 6.10125C28.484 5.79349 28.902 5.62037 29.3381 5.61987H97.3205C97.7566 5.62037 98.1747 5.79349 98.483 6.10125C98.7914 6.40902 98.9648 6.82629 98.9653 7.26154V53.305L64.5601 67.9703C64.3413 68.0622 64.1062 68.1095 63.8688 68.1093ZM28.1319 52.9813L63.3651 67.5735C63.6937 67.7066 64.0618 67.7044 64.3888 67.5674L98.5267 53.016V7.26154C98.5263 6.94237 98.3991 6.63637 98.173 6.41068C97.9469 6.18499 97.6403 6.05803 97.3206 6.05765H29.3381C29.0183 6.05803 28.7118 6.18499 28.4857 6.41068C28.2595 6.63637 28.1323 6.94237 28.132 7.26154L28.1319 52.9813Z"
                    fill="#3F3D56"
                  />
                  <path
                    d="M123.965 42.3933H123.921L98.7456 53.1233L64.3005 67.8041C64.1659 67.8607 64.0215 67.8901 63.8754 67.8909C63.7294 67.8916 63.5847 67.8636 63.4495 67.8085L27.9123 53.0926L2.1184 42.4108L2.07899 42.3933H2.03509C1.6281 42.3938 1.2379 42.5553 0.950114 42.8426C0.662327 43.1298 0.500452 43.5193 0.5 43.9255V110.468C0.500452 110.874 0.662327 111.263 0.950114 111.551C1.2379 111.838 1.6281 112 2.03509 112H123.965C124.372 112 124.762 111.838 125.05 111.551C125.338 111.263 125.5 110.874 125.5 110.468V43.9255C125.5 43.5193 125.338 43.1298 125.05 42.8426C124.762 42.5553 124.372 42.3938 123.965 42.3933ZM125.061 110.468C125.061 110.758 124.946 111.036 124.74 111.242C124.535 111.447 124.256 111.562 123.965 111.562H2.03509C1.74432 111.562 1.46549 111.447 1.25988 111.242C1.05427 111.036 0.938713 110.758 0.938596 110.468V43.9255C0.938994 43.6425 1.04898 43.3706 1.24557 43.1666C1.44215 42.9627 1.71011 42.8424 1.99343 42.8311L27.9123 53.5654L63.2808 68.2135C63.6636 68.3689 64.0926 68.3666 64.4737 68.2069L98.7456 53.5982L124.009 42.8311C124.292 42.8433 124.559 42.9638 124.755 43.1677C124.951 43.3715 125.061 43.643 125.061 43.9255V110.468Z"
                    fill="#3F3D56"
                  />
                  <path
                    d="M63.514 54.9733C62.2058 54.9757 60.9322 54.5535 59.8855 53.7703L59.8206 53.7216L46.1559 43.279C45.5231 42.795 44.9919 42.1913 44.5928 41.5025C44.1937 40.8136 43.9345 40.053 43.8298 39.2642C43.7252 38.4753 43.7773 37.6736 43.9831 36.9048C44.1889 36.136 44.5444 35.4152 45.0293 34.7835C45.5141 34.1519 46.1189 33.6217 46.8091 33.2234C47.4992 32.825 48.2612 32.5662 49.0516 32.4618C49.8419 32.3574 50.6451 32.4093 51.4154 32.6148C52.1856 32.8202 52.9077 33.175 53.5406 33.659L62.3915 40.4331L83.3078 13.2062C83.7929 12.5747 84.3978 12.0448 85.0881 11.6466C85.7784 11.2485 86.5405 10.99 87.3309 10.8859C88.1213 10.7817 88.9245 10.834 89.6946 11.0397C90.4648 11.2454 91.1868 11.6005 91.8194 12.0847L91.6894 12.261L91.8228 12.0873C93.099 13.0663 93.934 14.5106 94.1446 16.1033C94.3553 17.696 93.9243 19.3071 92.9464 20.5831L68.3439 52.6085C67.7749 53.3465 67.0432 53.9437 66.2056 54.3538C65.368 54.7639 64.4469 54.9759 63.514 54.9733Z"
                    fill="#16407A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1017_28415">
                    <rect
                      width="125"
                      height="112"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span
              class="text-center font-18 mt-2 font-weight-bold color-black mt-5"
            >
              Request sent!
            </span>
            <br />
            <span class="text-center font-18 mt-2 text-gray mt-5">
              We've sent an email requesting the activation of your company
              <br />
              to this client's account <br />
              Once approved, you will be able to submit invoices to this client
            </span>
          </div>
          <div class="text-center text--white mt-10">
            <v-btn
              color="#16407A"
              class="submit-btn"
              @click="$router.push('/vendors/clients')"
            >
              Okay
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model.trim="inviteSent" width="800" class="success-modal">
      <v-card class="text-center">
        <v-card-text class="success-modal pt-5">
          <span align="end" class="pt-0 pr-0">
            <p class="font-weight-bold" @click="inviteSent = false">X</p>
          </span>
          <div class="display">
            <div class="text-center">
              <svg
                width="126"
                height="112"
                viewBox="0 0 126 112"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1017_28415)">
                  <path
                    d="M124.403 42.8311C124.358 42.8311 124.315 42.8174 124.278 42.7918L63.629 0.633045C63.4444 0.505346 63.2251 0.437101 63.0005 0.437483C62.776 0.437865 62.5569 0.506856 62.3727 0.635183L2.16072 42.7914C2.1131 42.8248 2.05416 42.8379 1.99686 42.8278C1.93956 42.8178 1.8886 42.7854 1.8552 42.7379C1.8218 42.6904 1.80868 42.6315 1.81873 42.5743C1.82879 42.5171 1.86119 42.4663 1.90882 42.4329L62.1209 0.27671C62.3787 0.0970783 62.6854 0.000517809 62.9998 2.07673e-06C63.3142 -0.000513655 63.6213 0.0950393 63.8796 0.273824L124.529 42.4325C124.567 42.4592 124.596 42.4973 124.611 42.5414C124.626 42.5855 124.626 42.6333 124.612 42.6778C124.598 42.7222 124.571 42.7611 124.533 42.7887C124.495 42.8162 124.45 42.8311 124.403 42.8311Z"
                    fill="#3F3D56"
                  />
                  <path
                    d="M5.60156 44.3256L63.0603 1.82104L120.955 47.35L66.0209 79.855L36.1963 73.0694L5.60156 44.3256Z"
                    fill="#E6E6E6"
                  />
                  <path
                    d="M38.7139 99.9318H10.3279C10.1536 99.9321 9.98095 99.898 9.81985 99.8316C9.65876 99.7651 9.51236 99.6677 9.38903 99.5447C9.2657 99.4218 9.16787 99.2758 9.10112 99.1151C9.03436 98.9544 9 98.7821 9 98.6081C9 98.4342 9.03436 98.2619 9.10112 98.1012C9.16787 97.9405 9.2657 97.7945 9.38903 97.6715C9.51236 97.5486 9.65876 97.4511 9.81985 97.3847C9.98095 97.3183 10.1536 97.2842 10.3279 97.2844H38.7139C38.8882 97.2842 39.0609 97.3183 39.2219 97.3847C39.383 97.4511 39.5294 97.5486 39.6528 97.6715C39.7761 97.7945 39.8739 97.9405 39.9407 98.1012C40.0074 98.2619 40.0418 98.4342 40.0418 98.6081C40.0418 98.7821 40.0074 98.9544 39.9407 99.1151C39.8739 99.2758 39.7761 99.4218 39.6528 99.5447C39.5294 99.6677 39.383 99.7651 39.2219 99.8316C39.0609 99.898 38.8882 99.9321 38.7139 99.9318Z"
                    fill="#16407A"
                  />
                  <path
                    d="M20.5122 94.2407H10.3279C10.1536 94.2409 9.98095 94.2068 9.81985 94.1404C9.65876 94.074 9.51236 93.9765 9.38903 93.8536C9.2657 93.7306 9.16787 93.5846 9.10112 93.4239C9.03436 93.2632 9 93.0909 9 92.917C9 92.743 9.03436 92.5707 9.10112 92.41C9.16787 92.2493 9.2657 92.1033 9.38903 91.9804C9.51236 91.8574 9.65876 91.76 9.81985 91.6935C9.98095 91.6271 10.1536 91.593 10.3279 91.5933H20.5122C20.6865 91.593 20.8591 91.6271 21.0202 91.6935C21.1813 91.76 21.3277 91.8574 21.451 91.9804C21.5743 92.1033 21.6722 92.2493 21.7389 92.41C21.8057 92.5707 21.84 92.743 21.84 92.917C21.84 93.0909 21.8057 93.2632 21.7389 93.4239C21.6722 93.5846 21.5743 93.7306 21.451 93.8536C21.3277 93.9765 21.1813 94.074 21.0202 94.1404C20.8591 94.2068 20.6865 94.2409 20.5122 94.2407Z"
                    fill="#16407A"
                  />
                  <path
                    d="M63.8685 67.9999C63.6528 68.0001 63.439 67.9583 63.2393 67.8768L27.8027 53.2006V7.26147C27.8032 6.85525 27.9651 6.46579 28.2529 6.17855C28.5407 5.8913 28.9308 5.72972 29.3378 5.72925H97.3203C97.7273 5.72972 98.1174 5.8913 98.4052 6.17855C98.693 6.46579 98.8549 6.85525 98.8554 7.26147V53.2327L98.7888 53.2611L64.5168 67.8697C64.3115 67.9557 64.0911 68 63.8685 67.9999Z"
                    fill="white"
                  />
                  <path
                    d="M63.8688 68.1093C63.6387 68.1095 63.4108 68.065 63.1978 67.9782L27.6934 53.2738V7.26154C27.6939 6.82629 27.8673 6.40902 28.1756 6.10125C28.484 5.79349 28.902 5.62037 29.3381 5.61987H97.3205C97.7566 5.62037 98.1747 5.79349 98.483 6.10125C98.7914 6.40902 98.9648 6.82629 98.9653 7.26154V53.305L64.5601 67.9703C64.3413 68.0622 64.1062 68.1095 63.8688 68.1093ZM28.1319 52.9813L63.3651 67.5735C63.6937 67.7066 64.0618 67.7044 64.3888 67.5674L98.5267 53.016V7.26154C98.5263 6.94237 98.3991 6.63637 98.173 6.41068C97.9469 6.18499 97.6403 6.05803 97.3206 6.05765H29.3381C29.0183 6.05803 28.7118 6.18499 28.4857 6.41068C28.2595 6.63637 28.1323 6.94237 28.132 7.26154L28.1319 52.9813Z"
                    fill="#3F3D56"
                  />
                  <path
                    d="M123.965 42.3933H123.921L98.7456 53.1233L64.3005 67.8041C64.1659 67.8607 64.0215 67.8901 63.8754 67.8909C63.7294 67.8916 63.5847 67.8636 63.4495 67.8085L27.9123 53.0926L2.1184 42.4108L2.07899 42.3933H2.03509C1.6281 42.3938 1.2379 42.5553 0.950114 42.8426C0.662327 43.1298 0.500452 43.5193 0.5 43.9255V110.468C0.500452 110.874 0.662327 111.263 0.950114 111.551C1.2379 111.838 1.6281 112 2.03509 112H123.965C124.372 112 124.762 111.838 125.05 111.551C125.338 111.263 125.5 110.874 125.5 110.468V43.9255C125.5 43.5193 125.338 43.1298 125.05 42.8426C124.762 42.5553 124.372 42.3938 123.965 42.3933ZM125.061 110.468C125.061 110.758 124.946 111.036 124.74 111.242C124.535 111.447 124.256 111.562 123.965 111.562H2.03509C1.74432 111.562 1.46549 111.447 1.25988 111.242C1.05427 111.036 0.938713 110.758 0.938596 110.468V43.9255C0.938994 43.6425 1.04898 43.3706 1.24557 43.1666C1.44215 42.9627 1.71011 42.8424 1.99343 42.8311L27.9123 53.5654L63.2808 68.2135C63.6636 68.3689 64.0926 68.3666 64.4737 68.2069L98.7456 53.5982L124.009 42.8311C124.292 42.8433 124.559 42.9638 124.755 43.1677C124.951 43.3715 125.061 43.643 125.061 43.9255V110.468Z"
                    fill="#3F3D56"
                  />
                  <path
                    d="M63.514 54.9733C62.2058 54.9757 60.9322 54.5535 59.8855 53.7703L59.8206 53.7216L46.1559 43.279C45.5231 42.795 44.9919 42.1913 44.5928 41.5025C44.1937 40.8136 43.9345 40.053 43.8298 39.2642C43.7252 38.4753 43.7773 37.6736 43.9831 36.9048C44.1889 36.136 44.5444 35.4152 45.0293 34.7835C45.5141 34.1519 46.1189 33.6217 46.8091 33.2234C47.4992 32.825 48.2612 32.5662 49.0516 32.4618C49.8419 32.3574 50.6451 32.4093 51.4154 32.6148C52.1856 32.8202 52.9077 33.175 53.5406 33.659L62.3915 40.4331L83.3078 13.2062C83.7929 12.5747 84.3978 12.0448 85.0881 11.6466C85.7784 11.2485 86.5405 10.99 87.3309 10.8859C88.1213 10.7817 88.9245 10.834 89.6946 11.0397C90.4648 11.2454 91.1868 11.6005 91.8194 12.0847L91.6894 12.261L91.8228 12.0873C93.099 13.0663 93.934 14.5106 94.1446 16.1033C94.3553 17.696 93.9243 19.3071 92.9464 20.5831L68.3439 52.6085C67.7749 53.3465 67.0432 53.9437 66.2056 54.3538C65.368 54.7639 64.4469 54.9759 63.514 54.9733Z"
                    fill="#16407A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1017_28415">
                    <rect
                      width="125"
                      height="112"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span
              class="text-center font-18 mt-2 font-weight-bold color-black mt-5"
            >
              Invite sent!
            </span>
            <br />
            <span class="text-center font-18 mt-2 text-gray mt-5">
              We've sent an invitation to this TPA. Once the TPA and client are
              <br />
              active on Apaly, you will be able to submit invoices to them.
            </span>
          </div>
          <div class="text-center text--white mt-10">
            <v-btn
              color="#16407A"
              class="submit-btn"
              @click="$router.push('/vendors/clients')"
            >
              Okay
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model.trim="TPAexists" width="800" class="success-modal">
      <v-card class="text-center">
        <v-card-text class="success-modal pt-5">
          <div class="display">
            <div class="text-center mt-5">
              <svg
                width="150"
                height="170"
                viewBox="0 0 199 201"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M167.855 23.1666C159.703 30.767 151.942 38.7774 144.605 47.1666C140.771 51.5833 137.438 55.5 134.855 58.5833C134.178 59.246 133.454 59.8587 132.688 60.4166L120.188 49.3333C119.658 48.9244 118.986 48.743 118.322 48.829C117.658 48.9149 117.055 49.2612 116.646 49.7916C116.237 50.3221 116.056 50.9932 116.142 51.6574C116.228 52.3216 116.574 52.9244 117.105 53.3333C119.688 55.5833 125.438 63.6666 128.521 67C129.348 68.0544 130.402 68.9089 131.605 69.5C132.278 69.7083 132.987 69.7788 133.689 69.7072C134.39 69.6356 135.07 69.4235 135.688 69.0833C139.086 67.2075 142.108 64.7215 144.605 61.75C147.573 58.5218 150.355 55.1274 152.938 51.5833C159.605 43.25 166.355 32.9166 171.438 27.1666C171.967 26.6356 172.264 25.9164 172.264 25.1666C172.264 24.4169 171.967 23.6977 171.438 23.1666C170.92 22.7811 170.292 22.5729 169.646 22.5729C169.001 22.5729 168.372 22.7811 167.855 23.1666Z"
                  fill="black"
                />
                <path
                  d="M63.1052 65.9167C61.3845 65.172 59.5993 64.5862 57.7719 64.1667C62.4478 60.5879 66.1452 55.8873 68.5219 50.5C82.2719 19.75 39.3552 8.33334 21.9385 29.5C13.3552 40.1667 11.7719 55 24.4385 64.0833C25.9254 65.063 27.4856 65.9267 29.1052 66.6667C22.4855 70.1204 16.775 75.0885 12.4385 81.1667C7.20819 89.2602 3.5866 98.2859 1.77186 107.75C-0.440627 116.994 -0.582909 126.612 1.35519 135.917C1.9317 138.643 3.43297 141.087 5.60469 142.833C7.77642 144.58 10.4851 145.522 13.2719 145.5C15.5467 145.441 17.7748 144.841 19.7719 143.75C19.3476 151.327 19.3476 158.923 19.7719 166.5C20.2221 173.018 21.2257 179.486 22.7719 185.833C23.7602 190.024 26.1853 193.735 29.6259 196.323C33.0665 198.911 37.3051 200.212 41.6052 200C45.6606 199.783 49.5742 198.434 52.9027 196.107C56.2312 193.78 58.8416 190.567 60.4385 186.833C62.2179 182.294 63.3403 177.523 63.7719 172.667C64.6885 164.333 64.6052 154.917 64.7719 145.167H67.1052C70.5807 145.064 73.9082 143.736 76.5003 141.419C79.0923 139.101 80.7823 135.942 81.2719 132.5C83.874 118.453 83.874 104.047 81.2719 90C80.3505 84.8401 78.2253 79.9702 75.0688 75.7856C71.9124 71.6011 67.8135 68.22 63.1052 65.9167ZM28.0219 34.0833C41.5219 14.75 70.1052 28.5 61.3552 47C60.0016 49.9785 58.0431 52.6428 55.6042 54.8234C53.1653 57.0041 50.2993 58.6535 47.1885 59.6667C44.1681 60.5174 40.9907 60.6515 37.9093 60.0584C34.8279 59.4653 31.9274 58.1612 29.4385 56.25C21.2719 50.9167 23.0219 41.6667 28.0219 34.0833ZM73.8552 131.667C73.6831 133.427 72.8946 135.069 71.629 136.304C70.3635 137.539 68.7022 138.288 66.9385 138.417C63.8552 138.417 60.9385 136.333 60.2719 131.417C60.2719 128.25 59.6052 124.917 59.4385 121.417C59.2719 117.917 59.4385 114.583 59.4385 111.25C59.4619 110.868 59.4053 110.485 59.2723 110.126C59.1393 109.767 58.9329 109.44 58.6662 109.166C58.3995 108.891 58.0784 108.675 57.7235 108.532C57.3687 108.389 56.9877 108.321 56.6052 108.333C56.2331 108.322 55.8624 108.385 55.5144 108.517C55.1664 108.649 54.8478 108.849 54.577 109.104C54.3061 109.359 54.0882 109.666 53.9358 110.005C53.7833 110.345 53.6993 110.711 53.6885 111.083C53.6885 114.5 53.6885 118.083 53.6885 121.583C53.6885 125.083 53.6885 128.833 54.2719 132.167C54.3517 134.152 54.8364 136.1 55.6962 137.891C56.556 139.683 57.7728 141.279 59.2719 142.583C58.4385 150.917 57.8552 159.75 56.8552 167.583C56.2464 173.048 54.7253 178.372 52.3552 183.333C51.313 185.435 49.7113 187.208 47.7265 188.457C45.7416 189.707 43.4505 190.385 41.1052 190.417C38.9958 190.431 36.9417 189.742 35.2669 188.459C33.5921 187.177 32.3918 185.373 31.8552 183.333C29.4757 176.128 27.8285 168.702 26.9385 161.167C25.9072 153.763 25.2951 146.306 25.1052 138.833C25.3524 138.577 25.5756 138.298 25.7719 138C27.7632 134.443 29.0638 130.541 29.6052 126.5C30.2007 120.966 30.3957 115.396 30.1885 109.833C30.1889 109.184 29.937 108.561 29.486 108.094C29.035 107.628 28.4204 107.355 27.7719 107.333C27.4408 107.31 27.1085 107.356 26.7958 107.467C26.4831 107.578 26.1966 107.753 25.9542 107.979C25.7119 108.206 25.5188 108.48 25.3871 108.785C25.2553 109.09 25.1877 109.418 25.1885 109.75C25.2922 115.011 25.0417 120.273 24.4385 125.5C23.8846 128.782 22.6957 131.924 20.9385 134.75C20.201 135.994 19.1524 137.025 17.8958 137.741C16.6393 138.456 15.2181 138.833 13.7719 138.833C12.5289 138.749 11.3529 138.239 10.4422 137.389C9.53142 136.539 8.94151 135.401 8.77186 134.167C7.52173 125.982 8.06193 117.623 10.3552 109.667C12.1246 101.585 15.3737 93.9 19.9385 87C24.3931 80.9389 30.5393 76.3293 37.6052 73.75C44.7588 71.4509 52.5121 71.8965 59.3552 75C62.8649 76.6692 65.9271 79.1494 68.2889 82.2358C70.6508 85.3221 72.2445 88.9261 72.9385 92.75C75.6324 105.556 75.9432 118.748 73.8552 131.667Z"
                  fill="black"
                />
                <path
                  d="M198.69 39.4167C198.69 33.1667 198.69 17.9167 198.69 11.4167C198.567 9.09958 197.655 6.89416 196.106 5.16667C191.46 3.07518 186.449 1.91442 181.356 1.75C172.356 0.75 160.44 0 151.856 0C148.523 0 120.023 0 103.273 1.08333C98.3505 1.10262 93.4901 2.1827 89.0229 4.25C87.1861 7.23286 86.2059 10.6637 86.1895 14.1667C85.4395 23.5 85.6062 39.1667 85.6895 44C85.7729 48.8333 86.5229 65.6667 87.2729 76C87.2729 79.4167 87.7729 82.1667 88.0229 83.4167C88.1222 84.3405 88.5 85.2124 89.1062 85.9167C90.8875 87.4195 93.112 88.2976 95.4395 88.4167C99.4582 88.7987 103.504 88.7987 107.523 88.4167C111.171 87.9331 114.843 87.6549 118.523 87.5833C126.273 87.5833 125.523 89.0833 125.773 89.9167C126.346 92.8332 126.346 95.8334 125.773 98.75C125.008 103.027 123.173 107.04 120.44 110.417C120.034 110.844 119.767 111.384 119.674 111.965C119.582 112.547 119.667 113.143 119.92 113.675C120.172 114.207 120.58 114.651 121.089 114.947C121.599 115.243 122.185 115.377 122.773 115.333C124.324 115.499 125.888 115.499 127.44 115.333C134.043 114.35 140.214 111.452 145.19 107C147.466 104.682 149.504 102.142 151.273 99.4167C153.94 95.25 155.606 91.0833 157.106 89.1667C160.856 89.1667 168.773 90.0833 176.106 90.6667C180.156 90.9608 184.223 90.9608 188.273 90.6667C190.94 90.5889 193.512 89.6538 195.606 88C197.578 84.4617 198.584 80.4668 198.523 76.4167C199.44 64.5 198.606 44.1667 198.69 39.4167ZM176.523 83.3333C168.94 82.8333 160.606 82.1667 156.773 82.4167C155.062 82.3605 153.394 82.9562 152.106 84.0833C150.356 86.1667 148.523 91 145.273 96.3333C143.854 98.7098 142.207 100.942 140.356 103C136.876 106.193 132.577 108.357 127.94 109.25C129.786 105.438 130.889 101.309 131.19 97.0833C132.356 83.25 125.273 82.25 118.523 82.1667C114.681 82.1401 110.842 82.3348 107.023 82.75C104.441 82.8868 101.854 82.8868 99.2728 82.75C97.6135 82.8146 95.9543 82.6177 94.3562 82.1667C94.3562 81.5833 94.3562 80.6667 94.3562 79.8333C93.7729 70.9167 93.2729 49.3333 93.3562 44.3333C93.3562 41.0833 93.3562 33.5 93.8562 26C93.9476 21.0612 94.3652 16.1338 95.1062 11.25C95.8077 10.9854 96.5333 10.79 97.2729 10.6667C101.606 10.0833 108.523 9.83333 116.023 9.66667C131.606 9.66667 149.356 9.66667 152.023 9.66667C157.856 9.66667 165.44 10.0833 172.44 10.6667C179.44 11.25 184.69 11.8333 188.44 12.5H189.19C189.773 19 189.606 33.4167 189.606 39.4167C189.606 43 190.19 56.0833 190.273 67.1667C190.273 72.8333 190.773 79.8333 190.273 83.1667C185.704 83.6432 181.102 83.699 176.523 83.3333Z"
                  fill="#3397FA"
                />
              </svg>
            </div>
            <span class="text-center mt-2 font-weight-bold color-black mt-5">
              <h2>A TPA with this email already exists!</h2>
            </span>
            <br />
            <span class="text-center mt-2 font-weight-bold color-black mt-5">
              <h2>
                Would you like to send this TPA a request to add this <br />
                employer/client to the platform?
              </h2>
            </span>
          </div>
          <div class="d-flex col-md-12 text--white mt-10">
            <span class="col-md-6">
              <v-btn
                color="#16407A"
                outlined
                @click="$router.push('/vendors/clients')"
              >
                NO
              </v-btn>
            </span>
            <span class="col-md-6">
              <v-btn color="#16407A" outlined @click="sendAnInvite()">
                YES
              </v-btn>
            </span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model.trim="newTPA" width="800" class="success-modal">
      <v-card class="text-center">
        <v-card-text class="success-modal pt-5">
          <span align="end" class="pt-0 pr-0">
            <p class="font-weight-bold" @click="newTPA = false">X</p>
          </span>
          <div class="display">
            <div class="text-center">
              <svg
                width="126"
                height="112"
                viewBox="0 0 126 112"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1017_28415)">
                  <path
                    d="M124.403 42.8311C124.358 42.8311 124.315 42.8174 124.278 42.7918L63.629 0.633045C63.4444 0.505346 63.2251 0.437101 63.0005 0.437483C62.776 0.437865 62.5569 0.506856 62.3727 0.635183L2.16072 42.7914C2.1131 42.8248 2.05416 42.8379 1.99686 42.8278C1.93956 42.8178 1.8886 42.7854 1.8552 42.7379C1.8218 42.6904 1.80868 42.6315 1.81873 42.5743C1.82879 42.5171 1.86119 42.4663 1.90882 42.4329L62.1209 0.27671C62.3787 0.0970783 62.6854 0.000517809 62.9998 2.07673e-06C63.3142 -0.000513655 63.6213 0.0950393 63.8796 0.273824L124.529 42.4325C124.567 42.4592 124.596 42.4973 124.611 42.5414C124.626 42.5855 124.626 42.6333 124.612 42.6778C124.598 42.7222 124.571 42.7611 124.533 42.7887C124.495 42.8162 124.45 42.8311 124.403 42.8311Z"
                    fill="#3F3D56"
                  />
                  <path
                    d="M5.60156 44.3256L63.0603 1.82104L120.955 47.35L66.0209 79.855L36.1963 73.0694L5.60156 44.3256Z"
                    fill="#E6E6E6"
                  />
                  <path
                    d="M38.7139 99.9318H10.3279C10.1536 99.9321 9.98095 99.898 9.81985 99.8316C9.65876 99.7651 9.51236 99.6677 9.38903 99.5447C9.2657 99.4218 9.16787 99.2758 9.10112 99.1151C9.03436 98.9544 9 98.7821 9 98.6081C9 98.4342 9.03436 98.2619 9.10112 98.1012C9.16787 97.9405 9.2657 97.7945 9.38903 97.6715C9.51236 97.5486 9.65876 97.4511 9.81985 97.3847C9.98095 97.3183 10.1536 97.2842 10.3279 97.2844H38.7139C38.8882 97.2842 39.0609 97.3183 39.2219 97.3847C39.383 97.4511 39.5294 97.5486 39.6528 97.6715C39.7761 97.7945 39.8739 97.9405 39.9407 98.1012C40.0074 98.2619 40.0418 98.4342 40.0418 98.6081C40.0418 98.7821 40.0074 98.9544 39.9407 99.1151C39.8739 99.2758 39.7761 99.4218 39.6528 99.5447C39.5294 99.6677 39.383 99.7651 39.2219 99.8316C39.0609 99.898 38.8882 99.9321 38.7139 99.9318Z"
                    fill="#16407A"
                  />
                  <path
                    d="M20.5122 94.2407H10.3279C10.1536 94.2409 9.98095 94.2068 9.81985 94.1404C9.65876 94.074 9.51236 93.9765 9.38903 93.8536C9.2657 93.7306 9.16787 93.5846 9.10112 93.4239C9.03436 93.2632 9 93.0909 9 92.917C9 92.743 9.03436 92.5707 9.10112 92.41C9.16787 92.2493 9.2657 92.1033 9.38903 91.9804C9.51236 91.8574 9.65876 91.76 9.81985 91.6935C9.98095 91.6271 10.1536 91.593 10.3279 91.5933H20.5122C20.6865 91.593 20.8591 91.6271 21.0202 91.6935C21.1813 91.76 21.3277 91.8574 21.451 91.9804C21.5743 92.1033 21.6722 92.2493 21.7389 92.41C21.8057 92.5707 21.84 92.743 21.84 92.917C21.84 93.0909 21.8057 93.2632 21.7389 93.4239C21.6722 93.5846 21.5743 93.7306 21.451 93.8536C21.3277 93.9765 21.1813 94.074 21.0202 94.1404C20.8591 94.2068 20.6865 94.2409 20.5122 94.2407Z"
                    fill="#16407A"
                  />
                  <path
                    d="M63.8685 67.9999C63.6528 68.0001 63.439 67.9583 63.2393 67.8768L27.8027 53.2006V7.26147C27.8032 6.85525 27.9651 6.46579 28.2529 6.17855C28.5407 5.8913 28.9308 5.72972 29.3378 5.72925H97.3203C97.7273 5.72972 98.1174 5.8913 98.4052 6.17855C98.693 6.46579 98.8549 6.85525 98.8554 7.26147V53.2327L98.7888 53.2611L64.5168 67.8697C64.3115 67.9557 64.0911 68 63.8685 67.9999Z"
                    fill="white"
                  />
                  <path
                    d="M63.8688 68.1093C63.6387 68.1095 63.4108 68.065 63.1978 67.9782L27.6934 53.2738V7.26154C27.6939 6.82629 27.8673 6.40902 28.1756 6.10125C28.484 5.79349 28.902 5.62037 29.3381 5.61987H97.3205C97.7566 5.62037 98.1747 5.79349 98.483 6.10125C98.7914 6.40902 98.9648 6.82629 98.9653 7.26154V53.305L64.5601 67.9703C64.3413 68.0622 64.1062 68.1095 63.8688 68.1093ZM28.1319 52.9813L63.3651 67.5735C63.6937 67.7066 64.0618 67.7044 64.3888 67.5674L98.5267 53.016V7.26154C98.5263 6.94237 98.3991 6.63637 98.173 6.41068C97.9469 6.18499 97.6403 6.05803 97.3206 6.05765H29.3381C29.0183 6.05803 28.7118 6.18499 28.4857 6.41068C28.2595 6.63637 28.1323 6.94237 28.132 7.26154L28.1319 52.9813Z"
                    fill="#3F3D56"
                  />
                  <path
                    d="M123.965 42.3933H123.921L98.7456 53.1233L64.3005 67.8041C64.1659 67.8607 64.0215 67.8901 63.8754 67.8909C63.7294 67.8916 63.5847 67.8636 63.4495 67.8085L27.9123 53.0926L2.1184 42.4108L2.07899 42.3933H2.03509C1.6281 42.3938 1.2379 42.5553 0.950114 42.8426C0.662327 43.1298 0.500452 43.5193 0.5 43.9255V110.468C0.500452 110.874 0.662327 111.263 0.950114 111.551C1.2379 111.838 1.6281 112 2.03509 112H123.965C124.372 112 124.762 111.838 125.05 111.551C125.338 111.263 125.5 110.874 125.5 110.468V43.9255C125.5 43.5193 125.338 43.1298 125.05 42.8426C124.762 42.5553 124.372 42.3938 123.965 42.3933ZM125.061 110.468C125.061 110.758 124.946 111.036 124.74 111.242C124.535 111.447 124.256 111.562 123.965 111.562H2.03509C1.74432 111.562 1.46549 111.447 1.25988 111.242C1.05427 111.036 0.938713 110.758 0.938596 110.468V43.9255C0.938994 43.6425 1.04898 43.3706 1.24557 43.1666C1.44215 42.9627 1.71011 42.8424 1.99343 42.8311L27.9123 53.5654L63.2808 68.2135C63.6636 68.3689 64.0926 68.3666 64.4737 68.2069L98.7456 53.5982L124.009 42.8311C124.292 42.8433 124.559 42.9638 124.755 43.1677C124.951 43.3715 125.061 43.643 125.061 43.9255V110.468Z"
                    fill="#3F3D56"
                  />
                  <path
                    d="M63.514 54.9733C62.2058 54.9757 60.9322 54.5535 59.8855 53.7703L59.8206 53.7216L46.1559 43.279C45.5231 42.795 44.9919 42.1913 44.5928 41.5025C44.1937 40.8136 43.9345 40.053 43.8298 39.2642C43.7252 38.4753 43.7773 37.6736 43.9831 36.9048C44.1889 36.136 44.5444 35.4152 45.0293 34.7835C45.5141 34.1519 46.1189 33.6217 46.8091 33.2234C47.4992 32.825 48.2612 32.5662 49.0516 32.4618C49.8419 32.3574 50.6451 32.4093 51.4154 32.6148C52.1856 32.8202 52.9077 33.175 53.5406 33.659L62.3915 40.4331L83.3078 13.2062C83.7929 12.5747 84.3978 12.0448 85.0881 11.6466C85.7784 11.2485 86.5405 10.99 87.3309 10.8859C88.1213 10.7817 88.9245 10.834 89.6946 11.0397C90.4648 11.2454 91.1868 11.6005 91.8194 12.0847L91.6894 12.261L91.8228 12.0873C93.099 13.0663 93.934 14.5106 94.1446 16.1033C94.3553 17.696 93.9243 19.3071 92.9464 20.5831L68.3439 52.6085C67.7749 53.3465 67.0432 53.9437 66.2056 54.3538C65.368 54.7639 64.4469 54.9759 63.514 54.9733Z"
                    fill="#16407A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1017_28415">
                    <rect
                      width="125"
                      height="112"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span
              class="text-center font-18 mt-2 font-weight-bold color-black mt-5"
            >
              Invite sent!
            </span>
            <br />
            <span class="text-center font-18 mt-2 text-gray mt-5">
              We've sent a request to this TPA. We'll notify you once this
              <br />
              employer is active in Apaly and you are able to submit invoices
              <br />
              to them
            </span>
          </div>
          <div class="text-center text--white mt-10">
            <v-btn
              color="#16407A"
              class="submit-btn"
              @click="$router.push('/vendors/clients')"
            >
              Okay
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model.trim="invite"
      style="margin-top: 30vh"
      content-class="vh-20"
      persistent
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5 text-underline col-md-12 font-weight-bolder"
            >Invite a TPA</span
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form class="row" ref="form" v-model="valid">
              <v-col cols="12" sm="12" md="12">
                <label for="">Client/Company Name</label>
                <v-text-field
                  :rules="requiredRules"
                  required
                  solo
                  v-model="compName"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <label for="">TPA Company Name</label>
                <v-text-field
                  :rules="requiredRules"
                  required
                  solo
                  v-model="tpaName"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <label for="">TPA Contact First Name</label>
                <v-text-field
                  :rules="requiredRules"
                  required
                  solo
                  v-model="tpaFirstName"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <label for="">TPA Contact Last Name</label>
                <v-text-field :rules="requiredRules" solo v-model="tpaLastName">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <label for="">TPA Contact Email</label>
                <v-text-field
                  :rules="requiredRules"
                  solo
                  v-model="tpaEmail"
                ></v-text-field>
              </v-col>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="col-md-12" align="end">
            <span
              class="text-underline blue--text mr-10 pointer"
              @click="invite = false"
              >Cancel</span
            >
            <span
              class="text-underline blue--text pointer"
              @click="inviteNewTPA()"
              >Invite</span
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <errorModal ref="error_modal" v-on:confirm="closeErrorModal"></errorModal>
  </v-row>
</template>
  <script>
import api from "../../../../services/api";
import successModal from "../../../TablesTemplate/SuccessDialog.vue";
import errorModal from "../../../TablesTemplate/ErrorDialog.vue";
export default {
  components: { successModal, errorModal },
  data() {
    return {
      noResult: false,
      list: {},
      addItem: {},
      search: "",
      searchTerm: "",
      display: true,
      input: "",
      newTPA: false,
      TPAexists: false,
      inviteSent: false,
      invite: false,
      requestDialog: false,
      taxId: "",
      compName: "",
      tpaEmail: "",
      tpaFirstName: "",
      tpaLastName: "",
      tpaName: "",
      client: {
        companyName: "",
        taxId: "",
        logo: "",
        phone: "",
        title: "",
        firstName: "",
        lastName: "",
        email: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        displayName: "",
        membersNo: "",
        employeesNo: "",
        tpas: [],
      },
      test: {},
      clients: [],
      phoneRules: [
        (v) =>
          /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(v) ||
          "Phone number must be in a valid format (XXX XXX XXXX)",
      ],
      states: [],
      discountRate: "",
      valid: false,
      zipRules: [
        (v) => (v && v.length == 5) || " Zip Code should be five digits long",
      ],
      requiredRules: [(v) => !!v || "This field is required"],
      emailRules: [
        (v) => !!v || "This field is required",
        (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-mail must be valid",
      ],
      taxIdRules: [
        (v) => !!v || "This field is required",
        (v) =>
          !!/[0-9]{2}\-[0-9]{7}/.test(v) ||
          "Tax ID should contain 9 digits, Please enter your Tax ID in XX-XXXXXXX format",
      ],
    };
  },

  computed: {
    singleMember() {
      return this.$store.getters.getSingleMember;
    },
  },
  created() {
    this.getStates();
  },
  methods: {
    selected(item) {
      this.addItem = item;
      this.search = item.companyName;
      const result = this.clients.find((x) => x._id === item._id);
      this.taxId = result.taxId;
      this.list = result;
      console.log('result', this.list);
      this.clients = [];
      this.display = false;
    },
    removeTpa(index) {
      this.list.splice(index, 1);
    },
    inviteNewTPA() {
      this.$refs.form.validate();
      if (this.valid) {
        let data = {
          client: this.compName,
          tpa: this.tpaName,
          firstName: this.tpaFirstName,
          lastName: this.tpaLastName,
          email: this.tpaEmail,
        };
        api()
          .post("/auth/validateEmail", { email: this.tpaEmail })
          .catch((err) => {
            if (err) {
              this.$refs.error_modal.openPopUp(err.response.data.message);
            }
          })
          .then((res) => {
            if (res) {
              api()
                .post("/vendors/tpa/check", { email: this.tpaEmail })
                .then((res) => {
                  if (res.data.exist == true) {
                    this.$refs.error_modal.openPopUp("Organization exists");
                  } else {
                    api()
                      .post("/vendors/tpa", data)
                      .catch((err) => {
                        if (err) {
                          this.$refs.error_modal.openPopUp(err.response.data);
                        }
                      })
                      .then((res) => {
                        console.log("res", res.data);
                        this.$refs.success_modal.openPopUp(res.data);
                      });
                  }
                });
            }
          });
      }
    },
    sendAnInvite() {
      this.TPAexists = false;
      this.newTPA = true;
    },
    closeErrorModal() {
      this.$refs.error_modal.closePopUp();
    },
    showSlash(event) {
      //  xedic69819@ishyp.com
      if (this.client.taxId.length == 2 && event.keyCode != 8) {
        this.client.taxId += "-";
      }
    },
    activateFileInput() {
      this.$refs.fileInput.$refs.input.click();
    },
    getStates() {
      api()
        .get("/api/states")
        .then((res) => {
          res.data.forEach((el) => {
            if (el.active) {
              this.states.push(el);
            }
          });
        });
    },
    getClientsOnKeyUp() {
      if (this.search.length > 0) {
        this.display = true;
        this.noResult = false;
        this.getClients(this.search);
      } else {
        this.clients = [];
        this.noResult = true;
        this.display = false;
      }
    },
    getClients() {
      api()
        .post("/vendors/search/clients", { companyName: this.search })
        .then((res) => {
          this.clients = res.data;
          if (this.clients.length < 1) {
            this.noResult = true;
          }
        });
    },
    addClient() {
     
        console.log("this", this.list);
        if (
          this.list &&
          this.list.tpas.length > 0
        ) {
          api()
            .post(
              `/vendors/client/${this.list._id}/tpa/${this.list.tpas[0]._id}`
            )
            .catch((err) => {
              if (err) {
                this.$refs.error_modal.openPopUp(err.response.data);
              }
            })
            .then((res) => {
              if(res){
                      this.$refs.success_modal.openPopUp(res.data);  
              }
      
            });
        } else {
          this.$refs.error_modal.openPopUp("Missing TPA");
        }
      
    },
    closeSuccessModal() {
      this.$refs.success_modal.closePopUp();
      this.$router.push("/vendors/clients");
    },

    update() {
      this.$refs.form.validate();
      if (this.valid) {
        let data = {
          companyName: this.client.companyName,
          taxId: this.client.taxId,
          noEmployees: this.client.noEmployees,
          noPlanMembers: this.client.noPlanMembers,
          address1: this.client.address1,
          address2: this.client.address2,
          city: this.client.city,
          state: this.client.state,
          zip: this.client.zip,
          firstName: this.client.firstName,
          lastName: this.client.lastName,
          title: this.client.title,
          email: this.client.email,
          phone: this.client.phone,
          status: this.client.status,
          tpas: this.client.tpas,
          noEmployees: this.client.employeesNo,
          noPlanMembers: this.client.membersNo,
        };

        api()
          .post(`/vendors/clients`, data)
          .catch((err) => {
            if (err) {
              this.$refs.error_modal.openPopUp(err.response.data);
            }
          })
          .then((res) => {
            if (res) {
              this.$parent.getData();
              this.requestDialog = true;
            }
          });
      }
    },
  },
};
</script>
  <style scoped>
.comp-info {
  color: #707070 !important;
}
.submit-btn {
  width: 130px;
  color: white;
}
.display {
  display: grid;
}
.color-black {
  color: black;
}
@media screen and (max-width: 768px) {
  .mobile{
    width: max-content;
  }

}
</style>
